const copyrightLicenseType = {
    AGENCY : 1,
    CARRIER : 2
};

angular.module('gw-um-j2js')
    .constant('copyrightLicenseType', copyrightLicenseType);